import { render, staticRenderFns } from "./supplyGoods.vue?vue&type=template&id=78843dec&scoped=true"
import script from "./supplyGoods.vue?vue&type=script&lang=js"
export * from "./supplyGoods.vue?vue&type=script&lang=js"
import style0 from "./supplyGoods.vue?vue&type=style&index=0&id=78843dec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78843dec",
  null
  
)

export default component.exports